webpackJsonp(["pages.projects.commits.show"],{

/***/ "./commits.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pager__ = __webpack_require__("./pager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var CommitsList = function () {
  function CommitsList() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    _classCallCheck(this, CommitsList);

    this.timer = null;

    this.$contentList = $('.content_list');

    __WEBPACK_IMPORTED_MODULE_2__pager__["a" /* default */].init(parseInt(limit, 10), false, false, this.processCommits.bind(this));

    this.content = $('#commits-list');
    this.searchField = $('#commits-search');
    this.lastSearch = this.searchField.val();
    this.initSearch();
  }

  _createClass(CommitsList, [{
    key: 'initSearch',
    value: function initSearch() {
      var _this = this;

      this.timer = null;
      this.searchField.on('keyup', function () {
        clearTimeout(_this.timer);
        _this.timer = setTimeout(_this.filterResults.bind(_this), 500);
      });
    }
  }, {
    key: 'filterResults',
    value: function filterResults() {
      var _this2 = this;

      var form = $('.commits-search-form');
      var search = this.searchField.val();
      if (search === this.lastSearch) return Promise.resolve();
      var commitsUrl = form.attr('action') + '?' + form.serialize();
      this.content.fadeTo('fast', 0.5);
      var params = form.serializeArray().reduce(function (acc, obj) {
        return Object.assign(acc, _defineProperty({}, obj.name, obj.value));
      }, {});

      return __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__["a" /* default */].get(form.attr('action'), {
        params: params
      }).then(function (_ref) {
        var data = _ref.data;

        _this2.lastSearch = search;
        _this2.content.html(data.html);
        _this2.content.fadeTo('fast', 1.0);

        // Change url so if user reload a page - search results are saved
        history.replaceState({
          page: commitsUrl
        }, document.title, commitsUrl);
      }).catch(function () {
        _this2.content.fadeTo('fast', 1.0);
        _this2.lastSearch = null;
      });
    }

    // Prepare loaded data.

  }, {
    key: 'processCommits',
    value: function processCommits(data) {
      var processedData = data;
      var $processedData = $(processedData);
      var $commitsHeadersLast = this.$contentList.find('li.js-commit-header').last();
      var lastShownDay = $commitsHeadersLast.data('day');
      var $loadedCommitsHeadersFirst = $processedData.filter('li.js-commit-header').first();
      var loadedShownDayFirst = $loadedCommitsHeadersFirst.data('day');
      var commitsCount = void 0;

      // If commits headers show the same date,
      // remove the last header and change the previous one.
      if (lastShownDay === loadedShownDayFirst) {
        // Last shown commits count under the last commits header.
        commitsCount = $commitsHeadersLast.nextUntil('li.js-commit-header').find('li.commit').length;

        // Remove duplicate of commits header.
        processedData = $processedData.not('li.js-commit-header[data-day=\'' + loadedShownDayFirst + '\']');

        // Update commits count in the previous commits header.
        commitsCount += Number($(processedData).nextUntil('li.js-commit-header').first().find('li.commit').length);
        $commitsHeadersLast.find('span.commits-count').text(commitsCount + ' ' + Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_text_utility__["g" /* pluralize */])('commit', commitsCount));
      }

      Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__["e" /* localTimeAgo */])($processedData.find('.js-timeago'));

      return processedData;
    }
  }]);

  return CommitsList;
}();

/* harmony default export */ __webpack_exports__["a"] = (CommitsList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./gpg_badges.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__("./locale/index.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var GpgBadges = function () {
  function GpgBadges() {
    _classCallCheck(this, GpgBadges);
  }

  _createClass(GpgBadges, null, [{
    key: 'fetch',
    value: function fetch() {
      var badges = $('.js-loading-gpg-badge');
      var form = $('.commits-search-form');

      badges.html('<i class="fa fa-spinner fa-spin"></i>');

      var params = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["A" /* parseQueryStringIntoObject */])(form.serialize());
      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(form.data('signaturesPath'), { params: params }).then(function (_ref) {
        var data = _ref.data;

        data.signatures.forEach(function (signature) {
          badges.filter('[data-commit-sha="' + signature.commit_sha + '"]').replaceWith(signature.html);
        });
      }).catch(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__locale__["a" /* __ */])('An error occurred while loading commits'));
      });
    }
  }]);

  return GpgBadges;
}();

/* harmony default export */ __webpack_exports__["a"] = (GpgBadges);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");




var ENDLESS_SCROLL_BOTTOM_PX = 400;
var ENDLESS_SCROLL_FIRE_DELAY_MS = 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var preload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var disable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var prepareData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $.noop;
    var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $.noop;

    this.url = $('.content_list').data('href') || Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__["f" /* removeParams */])(['limit', 'offset']);
    this.limit = limit;
    this.offset = parseInt(Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["i" /* getParameterByName */])('offset'), 10) || this.limit;
    this.disable = disable;
    this.prepareData = prepareData;
    this.callback = callback;
    this.loading = $('.loading').first();
    if (preload) {
      this.offset = 0;
      this.getOld();
    }
    this.initLoadMore();
  },
  getOld: function getOld() {
    var _this = this;

    this.loading.show();
    __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(this.url, {
      params: {
        limit: this.limit,
        offset: this.offset
      }
    }).then(function (_ref) {
      var data = _ref.data;

      _this.append(data.count, _this.prepareData(data.html));
      _this.callback();

      // keep loading until we've filled the viewport height
      if (!_this.disable && !_this.isScrollable()) {
        _this.getOld();
      } else {
        _this.loading.hide();
      }
    }).catch(function () {
      return _this.loading.hide();
    });
  },
  append: function append(count, html) {
    $('.content_list').append(html);
    if (count > 0) {
      this.offset += count;
    } else {
      this.disable = true;
    }
  },
  isScrollable: function isScrollable() {
    var $w = $(window);
    return $(document).height() > $w.height() + $w.scrollTop() + ENDLESS_SCROLL_BOTTOM_PX;
  },
  initLoadMore: function initLoadMore() {
    var _this2 = this;

    $(document).off('scroll');
    $(document).endlessScroll({
      bottomPixels: ENDLESS_SCROLL_BOTTOM_PX,
      fireDelay: ENDLESS_SCROLL_FIRE_DELAY_MS,
      fireOnce: true,
      ceaseFire: function ceaseFire() {
        return _this2.disable === true;
      },
      callback: function callback() {
        if (!_this2.loading.is(':visible')) {
          _this2.loading.show();
          _this2.getOld();
        }
      }
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pages/projects/commits/show/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commits__ = __webpack_require__("./commits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gpg_badges__ = __webpack_require__("./gpg_badges.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");




document.addEventListener('DOMContentLoaded', function () {
  new __WEBPACK_IMPORTED_MODULE_0__commits__["a" /* default */](document.querySelector('.js-project-commits-show').dataset.commitsLimit); // eslint-disable-line no-new
  new __WEBPACK_IMPORTED_MODULE_2__shortcuts_navigation__["a" /* default */](); // eslint-disable-line no-new
  __WEBPACK_IMPORTED_MODULE_1__gpg_badges__["a" /* default */].fetch();
});

/***/ }),

/***/ "./shortcuts_navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts__ = __webpack_require__("./shortcuts.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ShortcutsNavigation = function (_Shortcuts) {
  _inherits(ShortcutsNavigation, _Shortcuts);

  function ShortcutsNavigation() {
    _classCallCheck(this, ShortcutsNavigation);

    var _this = _possibleConstructorReturn(this, (ShortcutsNavigation.__proto__ || Object.getPrototypeOf(ShortcutsNavigation)).call(this));

    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g p', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g e', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project-activity');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g f', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-tree');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g c', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-commits');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g j', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-builds');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g n', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-network');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g d', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-repository-charts');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issues');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g b', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issue-boards');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g m', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-merge_requests');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g t', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g w', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-wiki');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g s', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-snippets');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-new-issue');
    });

    _this.enabledHelp.push('.hidden-shortcut.project');
    return _this;
  }

  return ShortcutsNavigation;
}(__WEBPACK_IMPORTED_MODULE_2__shortcuts__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsNavigation);

/***/ })

},["./pages/projects/commits/show/index.js"]);


// WEBPACK FOOTER //
// pages.projects.commits.show.b6c4be6c3aca5ad7cbe8.bundle.js